/**
 * Layout item helpers.
 * Selection groups are stored as itemType "Group" + GroupType "Selection".
 * Legacy editor value "Selection Group" is normalized to that shape.
 */

export function isGroupItem(item) {
  return (
    item?.itemType === "Group" || item?.itemType === "Selection Group"
  );
}

export function isSelectionGroupItem(item) {
  if (!item) return false;
  if (item.itemType === "Selection Group") return true;
  if (item.itemType === "Group" && item.GroupType === "Selection") return true;
  // Recover partially corrupted selection groups that still have SelectionName
  if (item.itemType === "Group" && item.SelectionName) return true;
  return false;
}

/** Normalize any Selection Group aliases to Group + GroupType Selection */
export function normalizeObjectsForEditor(objects) {
  if (!Array.isArray(objects)) return [];

  return objects.map((obj) => {
    if (!obj || typeof obj !== "object") return obj;

    const next = { ...obj };

    if (
      next.itemType === "Selection Group" ||
      (next.itemType === "Group" && next.SelectionName && !next.GroupType)
    ) {
      next.itemType = "Group";
      next.GroupType = "Selection";
    }

    if (Array.isArray(next.Objects)) {
      next.Objects = normalizeObjectsForEditor(next.Objects);
    }

    return next;
  });
}

/** Ensure API payload never sends legacy "Selection Group" itemType */
export function serializeObjectsForApi(objects) {
  if (!Array.isArray(objects)) return [];

  return objects.map((obj) => {
    if (!obj || typeof obj !== "object") return obj;

    const next = { ...obj };

    if (next.itemType === "Selection Group") {
      next.itemType = "Group";
      next.GroupType = "Selection";
    }

    if (Array.isArray(next.Objects)) {
      next.Objects = serializeObjectsForApi(next.Objects);
    }

    return next;
  });
}
